<!--  -->
<template>
  <div>
    <h3 class="h1-title" id="inputPL">
      评论
      <span>
        共
        <b class="commentcountindex">{{totalcount}}</b>条评语
      </span>
    </h3>
    <div class="leave-words">
      <!-- <textarea id="commentcontent" name="commentcontent" placeholder="请写下您的留言"></textarea> -->
      <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="textarea"></el-input>
      <!-- <p class="enternumber">
        <span id="text-count">0</span>/1000
      </p> -->
    </div>
    <div class="leave-words">
      <a href="javascript:;" @click="setComment" class="btn-tj">发表评论</a>
    </div>
    <h3 class="h1-title">
      最新评论
      <span>
        共
        <b class="commentcountindex">{{totalcount}}</b>条评语
      </span>
    </h3>
    <div v-loading="commentLoad">
      <div v-for="(item,index) in commentLists" :key="index" class="pl-li clearfix">
        <div class="pl-os">
          <a href="javascript:void(0)" class="zan" @click="setMartGood(item.id)">
            <span v-if="!item.iszan"></span>
            <span v-else class="redzan"></span>
          </a>
          {{item.zancount}}
        </div>
        <div class="pl-author">
          <img v-if="item.avater" :src="item.avater">
          <span v-if="item.realname">
            <span class="author-name">{{item.realname}}</span>
            {{item.company}}
            <span class="space-line">|</span>
            {{item.titles}}
          </span>
          <span v-else class="author-name">壹学者用户</span>
        </div>
        <div class="pl-detail">
          <ul>
            <li>
              <h4 class="mrh4 mrbox" style="height: 0px;">{{item.comment}}</h4>
              <p class="mt15">
                <a class="talk" href="javascript:;" @click="showComment(item.id)"></a>
                <a href="javascript:;" class="reply" @click="showText(item.id)">查看回复</a>
              </p>
              <el-collapse-transition>
                <div v-show="commentActive==item.id">
                  <div class="pt20">
                    <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="textarea1"></el-input>
                    <div class="leave-words">
                      <a href="javascript:;" @click="zsetComment(item.id)" class="btn-pj">发表评论</a>
                    </div>
                  </div>
                </div>
              </el-collapse-transition>
              <el-collapse-transition>
                <div v-show="textActive == (item.id+98765)">
                  <div
                    v-loading="secondcommentLoad"
                    v-for="(list,index) in secondcommentLists"
                    :key="index"
                  >
                    <div class="pl-author pt20">
                      <img :src="list.avater">
                      <span v-if="list.realname">
                        <span class="author-name">{{list.realname}}</span>
                        {{list.company}}
                        <span class="space-line">|</span>
                        {{list.titles}}
                      </span>
                      <span v-else class="author-name">壹学者用户</span>
                    </div>
                    <div class="pl-detail">
                      <ul>
                        <li>
                          <h4 class="mrh4 mrbox" style="height: 0px;">{{list.comment}}</h4>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </el-collapse-transition>
            </li>
          </ul>
        </div>
      </div>
      <p style="text-align:center">
        <a v-if="noMore" @click="getMore">加载更多评论内容</a>
        <a v-else>没有更多评论</a>
      </p>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { getCookie } from "../../common/util.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      textarea: "",
      textarea1: "",
      show5: false,
      show3: false,
      show4: false,
      commentLoad: false,
      secondcommentLoad: false,
      metaid: "",
      setParams: {
        mid: getCookie("1xuezhePC_LoginMid"),
        metaid: "",
        parentid: 0,
        replyparentid: 0,
        comment: ""
      },
      commentLists: [],
      secondcommentLists: [],
      commentActive: 0,
      textActive: 0,
      totalcount: 0,
      pagesize: 10,
      pageindex: 1
    };
  },
  props: {
    pinglunValue: String
    // props: ['post'],
  },
  //监听属性 类似于data概念
  computed: {
    noMore() {
      return this.totalcount >= this.pagesize * this.pageindex;
    }
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    getMore() {
      if (this.noMore) {
        this.pageindex += 1;
        this.getComment(this.metaid);
      }
    },
    getComment(metaid, zan = "") {
      let _this = this;
      //如果是一个新的metaid，初始化
      if (metaid != _this.metaid) {
        _this.totalcount = 0;
        _this.commentLists = [];
        _this.pageindex = 1;
      }
      _this.metaid = metaid;
      let params = {
        metaid: metaid,
        pagesize: _this.pagesize,
        pageindex: _this.pageindex,
        mid:getCookie("1xuezhePC_LoginMid")
      };

      _this.commentLoad = true;

      _this.totalcount = 0;
      _this.$api
        .fetchGet("/iseapi/getisecomment", params)
        .then(res => {
          if (res.data.length > 0) {
            if (zan == "zan") {
              _this.commentLists = res.data;
            } else {
              _this.commentLists = res.data;
            }
            _this.totalcount = res.totalcount;
          }
          console.log(res);
          _this.commentLoad = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getisesecondcomment(id) {
      let _this = this;
      let params = {
        mid: getCookie("1xuezhePC_LoginMid"),
        metaid: _this.metaid,
        parentid: id
      };
      _this.secondcommentLoad = true;
      _this.secondcommentLists = [];
      _this.$api
        .fetchGet("/iseapi/getisesecondcomment", params)
        .then(res => {
          console.log(res);
          if (res.data.length > 0) {
            _this.secondcommentLists = res.data;
          } else {
            _this.openPJ();
          }

          _this.secondcommentLoad = false;
          setTimeout(() => {
            _this.textActive = id + 98765;
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    //提交评论/iseapi/setcomment
    setComment() {
      let _this = this;
      if (_this.textarea == "") {
        _this.openPl();
      }else if(_this.textarea.length>1000){
        _this.openLen()
      } else {
        _this.setParams.parentid = 0;
        _this.setParams.replyparentid = 0;
        _this.setParams.metaid = _this.metaid;
        _this.setParams.comment = _this.textarea;
        _this.$api
          .fetchPost("/iseapi/setcomment", _this.setParams)
          .then(res => {
            if (res.error == 0) {
              _this.parentid = 0;
              _this.replyparentid = 0;
              _this.textarea = "";
              _this.setParams.comment = "";
              _this.getComment(_this.metaid);
            } else if (res.error == 50001) {
              _this.openDL();
              _this.textarea = "";
              _this.setParams.comment = "";
            } else {
              console.log(res);
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    //提交评论/iseapi/setcomment
    zsetComment(id) {
      let _this = this;
      if (_this.textarea1 == "") {
        _this.openPl();
      }else if(_this.textarea1.length>1000){
        _this.openLen()
      } else {
        _this.setParams.parentid = id;
        _this.setParams.replyparentid = id;
        _this.setParams.metaid = _this.metaid;
        _this.setParams.comment = _this.textarea1;
        _this.$api
          .fetchPost("/iseapi/setcomment", _this.setParams)
          .then(res => {
            console.log(res);
            if (res.error == 0) {
              _this.textarea1 = "";
              _this.setParams.comment = "";
              _this.getisesecondcomment(id);
            } else if (res.error == 50001) {
              _this.openDL();
              _this.textarea1 = "";
              _this.setParams.comment = "";
            } else {
              console.log(res);
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    //show-comment
    showComment(index) {
      if (this.commentActive == index) {
        this.commentActive = 0;
      } else {
        this.commentActive = index;
      }
    },
    //show-text
    showText(index) {
      if (this.textActive == index + 98765) {
        this.textActive = 0;
      } else {
        this.textActive = 0;

        setTimeout(() => {
          this.getisesecondcomment(index);
        });
      }
    },
    //点赞
    setMartGood(id) {
      let _this = this;
      let params = {
        mid: getCookie("1xuezhePC_LoginMid"),
        martgoodtype: 17,
        id: id
      };
      _this.$api
        .fetchPost("/iseapi/setmartgood", params)
        .then(res => {
          if (res.error == 50001) {
            _this.openDL();
          } else if (res.error == 0) {
            _this.getComment(_this.metaid, "zan");
          }
          console.log(res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    openPl() {
      const h = this.$createElement;
      this.$message({
        message: h("p", null, [
          h("span", null, "评论内容不能为空，请填写您的评论！")
        ]),
        offset: 100
      });
    },
    openLen() {
      const h = this.$createElement;
      this.$message({
        message: h("p", null, [
          h("span", null, "评论内容不能超过1000个字，请您缩减内容！")
        ]),
        offset: 100
      });
    },
    openDL() {
      const h = this.$createElement;
      this.$message({
        message: h("p", null, [
          h("span", null, "您还没有登录，请先登录再来评价")
        ]),
        offset: 100
      });
    },
    openPJ() {
      const h = this.$createElement;
      this.$message({
        message: h("p", null, [h("span", null, "暂无回复")]),
        offset: 100
      });
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style>
.mt15 {
  margin-top: 15px;
}
.pt20 {
  padding-top: 20px;
}
.reply {
  color: #4267b2;
  font-size: 14px;
}
.h1-title {
  height: 35px;
  line-height: 35px;
  color: #4267b2;
  margin-top: 45px;
  margin-bottom: 15px;
  font-weight: 500;
}
.h1-title span {
  font-size: 12px;
  color: #333;
  margin-left: 10px;
}
.leave-words {
  width: 100%;
  position: relative;
  text-align: right;
}
.leave-words textarea {
  min-width: 100%;
  max-width: 100%;
  height: 185px;
  border: 1px solid #e8e8e8;
  padding: 20px;
  box-sizing: border-box;
  outline: none;
  border-radius: 8px;
  margin-bottom: 30px;
  background-color: #f8fafc;
}
.leave-words .enternumber {
  position: absolute;
  bottom: 50px;
  right: 20px;
  color: #ccc;
  font-size: 14px;
}
.leave-words .btn-tj {
  padding: 0 46px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #fff;
  background-color: #4267b2;
  display: inline-block;
  border-radius: 2px;
}
.leave-words .btn-pj {
  margin-top: 30px;
  padding: 0 20px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #fff;
  background-color: #4267b2;
  display: inline-block;
  border-radius: 2px;
}

.pl-li {
  margin-bottom: 30px;
  position: relative;
}
.pl-li .pl-os {
  position: absolute;
  right: 0;
  top: 5px;
  font-size: 14px;
}
.zan {
  /* float: left; */
  display: inline-block;
  line-height: 20px;
  /* width: 65px; */
  margin-left: 25px;
  text-align: left;
}
.zan span {
  /* float: left; */
  display: inline-block;
  width: 20px;
  height: 20px;
  background: url("../../assets/zan.svg") no-repeat center;
  background-size: 100%;
  margin-right: 6px;
  transition: 0.3s;
}
.zan span:hover {
  transition: 0.3s;
  background: url("../../assets/redzan.svg") no-repeat center;
  background-size: 100%;
}
.zan .redzan {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: url("../../assets/redzan.svg") no-repeat center;
  background-size: 100%;
  margin-right: 6px;
}
.talk {
  /* float: left; */
  display: inline-block;
  width: 20px;
  height: 17px;
  position: relative;
  background: url("../../assets/comment.svg") no-repeat center;
  background-size: 100%;
  cursor: pointer;
  top: 4px;
  margin-right: 5px;
}
.pl-li .zan {
  margin-top: 0;
}

.pl-li .talk {
  margin-top: 0;
}

.pl-li .pl-author {
  height: 30px;
  line-height: 30px;
  color: #999;
  font-size: 14px;
}
.pl-li .pl-author img {
  float: left;
  margin-right: 15px;
  width: 30px;
  height: 30px;
  border-radius: 2px;
}
.pl-li .pl-author .author-name {
  color: #4267b2;
  margin-right: 10px;
}
.space-line {
  width: 1px;
  overflow: hidden;
  margin: 0 10px;
}
.pl-li .pl-detail {
  margin-left: 45px;
  /* margin-bottom: 40px; */
}
.pl-li .pl-detail ul {
  /* margin-bottom: 10px; */
  width: 740px;
}
.pl-li .pl-detail li {
  margin-top: 10px;
  position: relative;
}
.pl-li .pl-detail li.first {
  border-left: 1px solid #999;
  padding-left: 20px;
  padding: 5px 10px;
  color: #999;
}
.pl-li .pl-detail li .mrbox {
  height: 100% !important;
}
.pl-li .pl-detail li .mrh4 {
  height: 100%;
  /* overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical; */
  font-size: 14px;
  line-height: 24px;
  font-weight: normal;
  color: #333;
}
</style>


// WEBPACK FOOTER //
// src/view/home/comment.vue